import { cn } from '@platform/ui';

export function DevErrorDetails({ error, componentStack, className }: { error: unknown; componentStack?: string; className?: string }) {
  if (!import.meta.env.DEV) {
    return null;
  }

  const message = error instanceof Error ? error.message : String(error);
  const stack = error instanceof Error ? error.stack : undefined;

  return (
    <details
      open
      className={cn(
        'mt-4 w-full max-w-2xl rounded-lg border border-red-300 bg-red-50 p-4 text-left text-sm dark:border-red-800 dark:bg-red-950',
        className,
      )}
    >
      <summary className="cursor-pointer font-semibold text-red-700 dark:text-red-400">{message}</summary>
      {stack ? (
        <pre className="mt-2 overflow-x-auto whitespace-pre-wrap break-words text-red-600 text-xs dark:text-red-300">{stack}</pre>
      ) : null}
      {componentStack ? (
        <>
          <p className="mt-3 font-semibold text-red-700 dark:text-red-400">Component Stack</p>
          <pre className="mt-1 overflow-x-auto whitespace-pre-wrap break-words text-red-600 text-xs dark:text-red-300">
            {componentStack}
          </pre>
        </>
      ) : null}
    </details>
  );
}
